<template>
    <div class="container" v-bind="$attrs">
        <slot></slot>
    </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="less">
.container {
    max-width: @container-width;
    margin: 0 auto;
}
</style>
